import UI from "./components/UI";
import { useDispatch } from 'react-redux'
import { setUser, removeUser } from "./store/slice/userSlice";
import { useEffect, useState } from 'react'
import { check } from './http/usersAPI'



const App = () => {
  const dispatch = useDispatch()
  const [isAuthChecking, setIsAuthChecking] = useState(true)


  useEffect(() => {
    check()
      .then(data => {
        if (data?.user) {
          dispatch(setUser(data))
        } else {
          dispatch(removeUser(null))
        }
      })
      .finally(() => {
        setIsAuthChecking(false)
      })
  }, [dispatch])

  if (isAuthChecking) {
    return null
  }

  return (
    <>
      <UI />
    </>
  );


}

export default App;
